module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe3165c4926244ef8189e8a9c05b6fd5b.e3165c49.png";